import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-metro-pagination',
  templateUrl: './metro-pagination.component.html',
  standalone: false
})
export class MetroPaginationComponent {
  @Input() currentPage = 0;   // 👈 empieza en 0
  @Input() pageSize = 10;     // 👈 tamaño default
  @Input() totalItems = 0;    // 👈 cantidad default

  @Output() pageChange = new EventEmitter<number>();

  get totalPages(): number {
    if (!this.pageSize || this.pageSize <= 0) return 1;
    return Math.ceil(this.totalItems / this.pageSize);
  }

  goToPage(page: number) {
    // protejo para que no se salga de rango
    if (page < 0) page = 0;
    if (page >= this.totalPages) page = this.totalPages - 1;
    this.pageChange.emit(page);
  }
}
